import Vue from 'vue'



import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/css/reset.css';
import './assets/css/index.css';
import iView from 'iview';
import 'iview/dist/styles/iview.css';
import axios from 'axios';
import Cookies from 'js-cookie';
import http from './plugin/http.js'
import App from './App.vue'
import router from './router'
import store from './store'

import api from './config/apiConfig';
import msgCfg from './config/msg';
import config from './config/config';
import myUtil from './utils/util';

import httpUtil from './utils/httpUtil.js';
import job from './utils/job.js';
import service from './utils/service.js';
import sdnJob from './utils/sdnJob.js';

import Vuex from 'vuex';
Vue.use(Vuex);
// Vue.use(VueRouter);
Vue.config.productionTip = false

Vue.use(ElementUI);
Vue.use(iView);

Vue.prototype.$axios = axios;

Vue.prototype.$api = api;

Vue.prototype.$msgCfg = msgCfg;

Vue.prototype.$config = config;
Vue.prototype.$cookie = Cookies;
Vue.prototype.$httpUtil = httpUtil;
Vue.prototype.$job = job;
Vue.prototype.$service = service;
Vue.prototype.$util = myUtil;
Vue.use(http);
Vue.prototype.$sdnJob = sdnJob;

import './mixin'
// //注意：确定自己避免了路由守卫进入死循环
// let oneRun = true; //通过oneRun变量控制 避免陷入死循环
// router.beforeEach((to,from,next)=>{
// 	if(oneRun){
// 		oneRun = false;//必须在creatNewRouter() 执行
// 		createNewRouter();
// 		next({...to, replace: true})// 必不可少的，确保你的动态路由创建成功再去执行其它代码
// 	}
// })
//
// function createNewRouter() {
// 	//请在这里做你登陆之后所做的创建动态路由的事情 一模一样去做。
// 	new Vue({
// 		router,
// 		store,
// 		render: h => h(App)
// 	}).$mount('#app')
// 	this.$store.commit("updateMenulist");
// 	//不要用缓存，session或localstorage 否则会报错。你需要重新发出请求 登陆怎么做的 这里就怎么做的
// };
// new Vue({
//   router,
//   store,
//   render: h => h(App)
// }).$mount('#app' )
new Vue({
	el: '#app',
	router,
	store,
	components: {
		App
		// store.commit('updateMenulist');
	},
	render: h => h(App),
	template: '<App/>',
	mounted() {
		// 权限菜单过滤相关
		this.$store.commit('updateMenulist')
	}
})



// WEBPACK FOOTER //
// ./src/main.js